import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@mui/material/Typography';

import StatePage from '@/operator/pages/states/StatePage';
import { StyledTryAgainButton } from './Styles';
import errorImg from '@/operator/public/assets/images/background/fatalError.png';

function ErrorStep({ onDismiss }: { onDismiss: () => void }) {
    const { t } = useTranslation();

    return (
        <div style={{ paddingTop: '48px', paddingBottom: '48px' }}>
            <StatePage
                headline={t('Forms.Connections.Error.Headline')}
                description={t('Forms.Connections.Error.Description')}
                imagePath={errorImg}
                actionElement={
                    <StyledTryAgainButton onClick={onDismiss}>
                        <Typography
                            variant="h5"
                            style={{ padding: 0, margin: 0 }}
                        >
                            {t('Forms.Connections.Error.Button')}
                        </Typography>
                    </StyledTryAgainButton>
                }
                background="inherit"
                width="100%"
                height="100%"
                imgDimension="200px"
            />
        </div>
    );
}

export default ErrorStep;
